import { Flex } from '@chakra-ui/layout'
import { useToast } from '@chakra-ui/toast'
import {
  ReactFlowProvider, Edge,
  Connection,
  useNodesState,
  useEdgesState,
  addEdge,
  Background,
  ReactFlow
} from '@xyflow/react'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { FaSave } from 'react-icons/fa'
import 'reactflow/dist/style.css'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { IDepartment } from '../../../../../../interfaces'
import { appApi } from '../../../../../../services/appApi'
import { parseJwt } from '../../../../../../services/token'
import { buildReactFlowGraph } from './BuildReactFlowGraph'
import CustomNode from './CustomNode'

const nodeTypes = {
  custom: CustomNode
}

interface OrganogramaProps {
  departamentos: IDepartment[]
  cores: string[]
}

const Organograma: React.FC<OrganogramaProps> = ({ departamentos, cores }) => {
  const toast = useToast()
  const [Id, setId] = useState<string>()
  const [savedNodes, setSavedNodes] = useState<any[]>()

  // Quando já tiver carregado os dados do backend
  const { nodes: initialNodes, edges: initialEdges } = useMemo(() => {
    return buildReactFlowGraph(departamentos, cores, savedNodes)
  }, [departamentos, cores, savedNodes])

  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes as any)
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges as any)

  const onConnect = useCallback(
    (params: Edge | Connection) => setEdges((els) => addEdge(params, els)),
    [setEdges]
  )

  function onPost(): void {
    const data = {
      id: Id,
      empresaId: parseJwt().eid,
      nodes: nodes,
      edges: edges
    }
    appApi.post('OrganogramaNode', data).then(() => {
      toast({
        title: 'Posições do organograma salvas com sucesso',
        status: 'success',
        position: 'top',
        duration: 4000
      })
    }).catch(err => console.log(err))
  }

  function onGet(): void {
    appApi.get('OrganogramaNode').then(res => {
      if (res.status === 200) {
        const data = res.data
        setId(data.id)
        setSavedNodes(data.nodes)
      }
    }).catch(err => console.log(err))
  }

  useEffect(() => {
    if (parseJwt().adm === 'True') {
      onGet()
    }
  }, [])

  // UseEffect para atualizar o estado do ReactFlow quando mudar os departamentos ou os dados salvos
  useEffect(() => {
    setNodes(initialNodes as any)
    setEdges(initialEdges)
  }, [initialNodes, initialEdges])

  return (
    <Flex flexDir={'column'} gap={'1rem'} alignItems={'end'}>
      {parseJwt().adm === 'True' && <ButtonCmp
        VarColor='Rosa'
        leftIcon={<FaSave />}
        w={'12rem'}
        mr={'2rem'}
        onClick={onPost}
      >
        Salvar organograma
      </ButtonCmp>}
      <ReactFlowProvider>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          onConnect={onConnect}
          nodeTypes={nodeTypes as any}
          minZoom={0.05}
          fitView
          style={{
            minWidth: '95vw',
            maxWidth: '95vw',
            minHeight: '93vh',
            maxHeight: '93vh',
            border: '1px solid var(--c6)'
          }}
          defaultEdgeOptions={{
            style: { stroke: '#1961E0', strokeWidth: 2 }
          }}
        >
          <Background />
        </ReactFlow>
      </ReactFlowProvider>
    </Flex>
  )
}

export default Organograma
